var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongTupian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 12,
    height: 11,
    rx: 0.5,
    stroke: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6.5,
    r: 1.5,
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.338 13.374l5.386-4.836a.333.333 0 01.451.006L14 11.205",
    stroke: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMi41IiB3aWR0aD0iMTIiIGhlaWdodD0iMTEiIHJ4PSIwLjUiIHN0cm9rZT0iIzNGNDY1QyIvPgo8Y2lyY2xlIGN4PSI1LjUiIGN5PSI2LjUiIHI9IjEuNSIgc3Ryb2tlPSIjM0Y0NjVDIi8+CjxwYXRoIGQ9Ik01LjMzNzg5IDEzLjM3NDRMMTAuNzI0MiA4LjUzODFDMTAuODUzMiA4LjQyMjMgMTEuMDQ5NCA4LjQyNDY2IDExLjE3NTUgOC41NDM1M0wxNCAxMS4yMDUiIHN0cm9rZT0iIzNGNDY1QyIvPgo8L3N2Zz4K";
export { SvgTongyongTupian as ReactComponent };